// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7a920e03] .el-table .warning-row{background:#fdf5e6}", ""]);
// Exports
module.exports = exports;
